module.exports = __webpack_public_path__ + "img/Varia Intra Finance.2ab469ac.png";